// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { secretTypeGuard, bufferLikeGuard, jsonObjectGuard } from './../foundations/index.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    userId: z.string().min(1).max(21),
    type: secretTypeGuard,
    encryptedDek: bufferLikeGuard,
    iv: bufferLikeGuard,
    authTag: bufferLikeGuard,
    ciphertext: bufferLikeGuard,
    metadata: jsonObjectGuard.optional(),
    createdAt: z.number().optional(),
    updatedAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    userId: z.string().min(1).max(21),
    type: secretTypeGuard,
    encryptedDek: bufferLikeGuard,
    iv: bufferLikeGuard,
    authTag: bufferLikeGuard,
    ciphertext: bufferLikeGuard,
    metadata: jsonObjectGuard,
    createdAt: z.number(),
    updatedAt: z.number(),
});
export const Secrets = Object.freeze({
    table: 'secrets',
    tableSingular: 'secret',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        userId: 'user_id',
        type: 'type',
        encryptedDek: 'encrypted_dek',
        iv: 'iv',
        authTag: 'auth_tag',
        ciphertext: 'ciphertext',
        metadata: 'metadata',
        createdAt: 'created_at',
        updatedAt: 'updated_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'userId',
        'type',
        'encryptedDek',
        'iv',
        'authTag',
        'ciphertext',
        'metadata',
        'createdAt',
        'updatedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
